// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1KR2N","block":"Item_block__1Ou6t"};